import { useContext } from "react";
import { SelectRowsContext } from "../context";
import type { SelectRows } from "../hooks/grid/useSelectRows";

const useSelectRowsContext = <T = unknown>(): SelectRows<T> => {
  const context = useContext(SelectRowsContext);
  if (!context)
    throw new Error(
      "useSelectRowsContext must be used within SelectRowsContextProvider"
    );
  return context as SelectRows<T>;
};

export default useSelectRowsContext;
